import styled from 'styled-components';

const Muted = styled.p`
  text-align: center;
  color: ${props => props.theme.font.muted};
`;

export default Muted;
